import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import { EMAIL_RULE, SAVE, BACKTOLIST, EMAIL_RULE_LIST } from "../../../../shared/constants/Constants";
import DefaultButton from "../../../../shared/components/DefaultButton";
import EmailConditionBuilder from "./EmailConditionBuilder";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import "./EmailConditionBuilder.css";
import { loadStatusDropdownRequest } from "../../escalation_rule_builder/redux/Actions";
import { loadGroupByIDJobTitlesGetDataRequest, loadGroupByTypeAdminGetDataRequest } from "../../../group_jobtitles/redux/Actions";
import { loadEmailRuleFormAddDataRequest, loadEmailRuleGetDataRequest, loadEmailRuleUpdateDataRequest, ResetEmailRuleFormAddDataReset, resetEmailRuleFormUpdateData } from "../redux/Actions";
import { loadCategorySubCategoryConfigDataRequest } from "../../categories/redux/Actions";
import { loadCompanyDataRequest } from "../../../company/redux/Actions";


const TICKET_TYPE_OPTIONS = [
  { value: "Ticket", label: "Ticket" },
  { value: "Workflow", label: "Workflow" },
];

const EmailRuleForm = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const [saveType, setSaveType] = useState("");
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);  
  const { statusList } = useSelector((state) => state.ticketingDropdowns);
  const { emailrule, addSuccess, updateSuccess } = useSelector((state) => state.EmailRule);
  const { adminGroup, group } = useSelector((state) => state.groupJobtitle);
  // This is your new unified category data
  const categoryData = useSelector((store) => store.categories.categoryconfig?.data || []);  
  const isEditMode = !!id && !Number.isNaN(Number(id));
  let {companies } = useSelector((state) => state.company);
  
  console.log("categoryData", categoryData);
  console.log("emailrule", emailrule);
  console.log("adminGroup", adminGroup);
  console.log("group (assigned to users)", group);

  // Load dropdown data on mount
  useEffect(() => {
    dispatch(loadStatusDropdownRequest());
    dispatch(loadCategorySubCategoryConfigDataRequest());
    dispatch(loadGroupByTypeAdminGetDataRequest("admin"));
    dispatch(loadCompanyDataRequest());
    
    // Load email rule data if in edit mode
    if (id && !Number.isNaN(Number(id))) {
      dispatch(loadEmailRuleGetDataRequest(id));
    }
  }, [dispatch, id]);

  // Update assigned to options when group data changes
  useEffect(() => {
    if (group && Array.isArray(group)) {
      setAssignedToOptions(group);
    }
  }, [group]);

  // Populate form fields in edit mode
  // useEffect(() => {
  //   if (isEditMode && emailrule && categoryData.length > 0) {
  //     const emailRuleData = emailrule;
      
  //     // Find the category and subcategory by category_config_id
  //     let matchedCategory = null;
  //     let matchedSubCategory = null;
      
  //     for (const cat of categoryData) {
  //       const subCat = cat.sub_category?.find(
  //         sc => sc.config_id === emailRuleData.category_config_id
  //       );
  //       if (subCat) {
  //         matchedCategory = cat;
  //         matchedSubCategory = subCat;
  //         break;
  //       }
  //     }

  //     if (!matchedCategory || !matchedSubCategory) {
  //       console.log("Could not find matching category/subcategory for config_id:", emailRuleData.category_config_id);
  //       return;
  //     }

  //     console.log("Matched Category:", matchedCategory);
  //     console.log("Matched SubCategory:", matchedSubCategory);

  //     // Set subcategory options
  //     setSubCategoryOptions(matchedCategory.sub_category);

  //     // Load assigned to options if admin_group exists
  //     if (matchedSubCategory.admin_group) {
  //       dispatch(loadGroupByIDJobTitlesGetDataRequest(matchedSubCategory.admin_group));
  //     }

  //     // Update Formik values
  //     setTimeout(() => {
  //       formikRef.current?.setValues(prev => ({
  //         ...prev,
  //         category: matchedCategory.id?.toString(),
  //         subCategory: matchedSubCategory.config_id?.toString(),
  //         adminGroup: matchedSubCategory.admin_group?.toString() || "",
  //         assignedTo: matchedSubCategory.assigned_to?.toString() || ""
  //       }));
  //     }, 100);
  //   }
  // }, [emailrule, categoryData, isEditMode, dispatch]);

  // Get unique categories for dropdown
  const getCategoryOptions = (selectedTicketType, selectedCompany) => {
    if (!selectedTicketType || !selectedCompany) return [];

    // Get categories that have at least one subcategory matching this company
    const companyId = parseInt(selectedCompany);
    
    const filtered = categoryData.filter(cat => {
      if (cat.ticket_type?.toLowerCase() !== selectedTicketType?.toLowerCase()) return false;
      
      return cat.sub_category?.some(sc => 
        sc.company_id === companyId || sc.company_id === null
      );
    });

    // Deduplicate by category id
    const seen = new Set();
    return filtered.filter(cat => {
      if (seen.has(cat.id)) return false;
      seen.add(cat.id);
      return true;
    });
  };


  // Initial values
  const getInitialValues = () => {
    if (isEditMode && emailrule && categoryData.length > 0) {
      const emailRuleData = emailrule;

      let matchedCategory = null;
      let matchedSubCategory = null;

      for (const cat of categoryData) {
        if (
          cat.ticket_type?.toLowerCase() ===
          emailRuleData.ticket_type?.toLowerCase()
        ) {
          const subCat = cat.sub_category?.find(
            sc => sc.config_id === emailRuleData.category_config_id
          );

          if (subCat) {
            matchedCategory = cat;
            matchedSubCategory = subCat;
            break;
          }
        }
      }
      return {
        active: emailRuleData.is_active ?? true,
        stopProcessing: emailRuleData.stop_processing ?? false,
        ruleName: emailRuleData.rule_name || "",
        description: emailRuleData.description || "",
        incomingEmailAddresses: "visionhub@wirelessvision.com",
        incomingEmailDisplay: emailRuleData.incoming_email_address || "Vision Hub",
        ticketType: emailRuleData.ticket_type || "",
        status: emailRuleData.status_id?.toString() || "",
        company: emailRuleData.company_id?.toString() || "",  
        category: matchedCategory?.id?.toString() || "",
        subCategory: matchedSubCategory?.config_id?.toString() || "",
        adminGroup: matchedSubCategory?.admin_group?.toString() || "",
        assignedTo: matchedSubCategory?.assigned_to?.toString() || "",
        priorityId: emailRuleData.priority_id || 1,
        priorityOrder: emailRuleData.priority_order || 0,
        conditionGroups: emailRuleData.conditions?.groups?.map(group => ({
          internalOperator: group.logic || "AND",
          nextOperator: null,
          conditions: group.conditions.map(cond => ({
            field_code: cond.field,
            field_name: cond.field,
            operator: cond.operator,
            value: cond.value,
            valueLabel: cond.value,
            dataType: "STRING"
          }))
        })) || [],
      };
    }    
    return {
      enabled: true,
      stopProcessing: false,
      ruleName: "",
      description: "",
      incomingEmailAddresses: "visionhub@wirelessvision.com",
      incomingEmailDisplay: "Vision Hub",
      ticketType: "",
      status: "",
      company: "",
      category: "",
      subCategory: "",
      adminGroup: "",
      assignedTo: "",
      priorityId: 1,
      priorityOrder: 0,
      conditionGroups: [],
    };
  };

  const initialValues = React.useMemo(() => {  return getInitialValues();}, [emailrule, categoryData, isEditMode]);

 // to populate sub category
  useEffect(() => {
    if (isEditMode && emailrule && categoryData.length > 0) {
      const matchedCategory = categoryData.find(cat =>
        cat.ticket_type?.toLowerCase() === emailrule.ticket_type?.toLowerCase() &&
        cat.sub_category?.some(sc => sc.config_id === emailrule.category_config_id)
      );

      if (matchedCategory?.sub_category) {
        const companyId = parseInt(emailrule.company_id); 
        const filteredSubs = matchedCategory.sub_category.filter(sc =>
          sc.company_id === companyId || sc.company_id === null
        );
        setSubCategoryOptions(filteredSubs);
      }

      const matchedSubCat = matchedCategory?.sub_category?.find(
        sc => sc.config_id === emailrule.category_config_id
      );
      if (matchedSubCat?.admin_group) {
        dispatch(loadGroupByIDJobTitlesGetDataRequest(matchedSubCat.admin_group));
      }
    }
  }, [emailrule, categoryData]);
  
  // Validation schema
  const validationSchema = Yup.object({
    enabled: Yup.boolean(),
    stopProcessing: Yup.boolean(),
    ruleName: Yup.string().required("Rule Name is required"),
    description: Yup.string().required("Description is required"),
    incomingEmailAddresses: Yup.string().required("Incoming email addresses is required"),
    ticketType: Yup.string().required("Ticket Type is required"),
    status: Yup.string().required("Status is required"),
    company: Yup.string().required("Caompany is required"),
    category: Yup.string().required("Category is required"),
    subCategory: Yup.string().required("Sub Category is required"),
    conditionGroups: Yup.array().min(1, "At least one condition is required").of(
      Yup.object().shape({
        conditions: Yup.array()
          .min(1, "At least one condition is required")
          .of(
            Yup.object().shape({
              field_code: Yup.string().required("Field is required"),
              operator: Yup.string().required("Operator is required"),
              value: Yup.string().trim().required("Value is required")
            })
          )
      })
    )
  });

  // Handle category change - populate subcategories
  const handleCategoryChange = (name, value, setFieldValue, ticketType, company) => {
    setFieldValue("category", value);
    setFieldValue("subCategory", "");
    setFieldValue("adminGroup", "");
    setFieldValue("assignedTo", "");

    if (value) {
      const companyId = parseInt(company);
      const selectedCategory = categoryData.find(
        cat =>
          cat.id === parseInt(value) &&
          cat.ticket_type?.toLowerCase() === ticketType?.toLowerCase()
      );

      if (selectedCategory?.sub_category) {
        // Filter subcategories by selected company (include nulls as "all companies")
        const filteredSubs = selectedCategory.sub_category.filter(sc =>
          sc.company_id === companyId || sc.company_id === null
        );
        setSubCategoryOptions(filteredSubs);
      } else {
        setSubCategoryOptions([]);
      }
    } else {
      setSubCategoryOptions([]);
    }

    setAssignedToOptions([]);
  };

  // Handle subcategory change - auto-populate admin group and assigned to
  const handleSubCategoryChange = (name, value, setFieldValue, ticketType, categoryId) => {
    setFieldValue("subCategory", value);
    setFieldValue("adminGroup", "");
    setFieldValue("assignedTo", "");
    
    if (value) {
      // Find the selected subcategory across all categories
      const selectedCategory = categoryData.find(
          cat =>
            cat.id === parseInt(categoryId) &&
            cat.ticket_type?.toLowerCase() ===
              ticketType?.toLowerCase()
        );

        const selectedSubCat = selectedCategory?.sub_category?.find(
          sc => sc.config_id === parseInt(value)
        );
      
      if (selectedSubCat) {
        console.log("Selected subcategory:", selectedSubCat);
        
        // Set admin group from subcategory
        if (selectedSubCat.admin_group) {
          setFieldValue("adminGroup", selectedSubCat.admin_group?.toString());
          
          // Load assigned to options using the admin_group ID
          dispatch(loadGroupByIDJobTitlesGetDataRequest(selectedSubCat.admin_group));
        } else {
          console.log("No admin_group found in subcategory");
        }
        
        // Set assigned to if available
        if (selectedSubCat.assigned_to) {
          setFieldValue("assignedTo", selectedSubCat.assigned_to?.toString());
        }
      }
    } else {
      setAssignedToOptions([]);
    }
  };

  const handleTicketTypeChange = (name, value, setFieldValue) => {
    setFieldValue("ticketType", value);
    setFieldValue("company", "");
    setFieldValue("category", "");
    setFieldValue("subCategory", "");
    setFieldValue("adminGroup", "");
    setFieldValue("assignedTo", "");
    setSubCategoryOptions([]);
    setAssignedToOptions([]);
  };

  const handleCompanyChange = (name, value, setFieldValue) => {
    setFieldValue("company", value);
    setFieldValue("category", "");
    setFieldValue("subCategory", "");
    setFieldValue("adminGroup", "");
    setFieldValue("assignedTo", "");
    setSubCategoryOptions([]);
    setAssignedToOptions([]);
  };
  
  // Transform conditionGroups to match API format
  const transformConditionGroups = (conditionGroups) => {
    if (!conditionGroups || conditionGroups.length === 0) {
      return { groups: [] };
    }

    return {
      groups: conditionGroups.map(group => ({
        logic: group.internalOperator || "AND",
        conditions: (group.conditions || []).map(condition => ({
          field: condition.field_code || condition.field,
          operator: condition.operator,
          value: condition.value || ""
        }))
      }))
    };
  };
  
  const handleSubmit = (values, { resetForm }) => {
  if (isEditMode && emailrule) {
    const emailRuleData = emailrule;
    const payload = { id: emailRuleData.id };

    if (values.ruleName !== emailRuleData.rule_name) payload.rule_name = values.ruleName;
    if (values.description !== (emailRuleData.description || "")) payload.description = values.description || "";
      if (values.enabled !== (emailRuleData.is_active ?? true)) payload.is_active = values.enabled;
      if (values.stopProcessing !== (emailRuleData.stop_processing ?? false)) payload.stop_processing = values.stopProcessing;
      if (values.incomingEmailDisplay !== (emailRuleData.incoming_email_address || "Vision Hub")) payload.incoming_email_address = values.incomingEmailDisplay;

      const currentConditions = transformConditionGroups(values.conditionGroups);
      const originalConditions = emailRuleData.conditions || { groups: [] };
      if (JSON.stringify(currentConditions) !== JSON.stringify(originalConditions)) payload.conditions = currentConditions;

      if (values.ticketType !== emailRuleData.ticket_type) payload.ticket_type = values.ticketType;
      if (parseInt(values.status) !== parseInt(emailRuleData.status_id)) payload.status_id = parseInt(values.status);
      if (parseInt(values.subCategory) !== emailRuleData.category_config_id) payload.category_config_id = parseInt(values.subCategory);
      if ((values.priorityId || 1) !== (emailRuleData.priority_id || 1)) payload.priority_id = values.priorityId || 1;
      if ((values.priorityOrder || 0) !== (emailRuleData.priority_order || 0)) payload.priority_order = values.priorityOrder || 0;
      
      // Add company_id if changed
      if (parseInt(values.company) !== parseInt(emailRuleData.company_id)) {
        payload.company_id = parseInt(values.company);
      }

      dispatch(loadEmailRuleUpdateDataRequest(payload));
    } else {
      const payload = {
        rule_name: values.ruleName,
        description: values.description || "",
        is_active: values.active,
        stop_processing: values.stopProcessing,
        incoming_email_address: values.incomingEmailDisplay,
        conditions: transformConditionGroups(values.conditionGroups),
        ticket_type: values.ticketType,
        status_id: parseInt(values.status),
        category_config_id: parseInt(values.subCategory),
        company_id: parseInt(values.company),   // <-- add this
        priority_id: values.priorityId || 1,
        priority_order: values.priorityOrder || 0,
      };

      dispatch(loadEmailRuleFormAddDataRequest(payload));
    }

    if (saveType === "saveAndNew") {
      setTimeout(() => {
        resetForm();
        setSubCategoryOptions([]);
        setAssignedToOptions([]);
      }, 500);
    }
  };

  // Navigate after successful save
  useEffect(() => {
    if (addSuccess) {
      if (saveType === "save") {
        navigate("/emailrulelist");
      }

      if (saveType === "saveAndNew") {
        formikRef.current?.resetForm();
        setSubCategoryOptions([]);
        setAssignedToOptions([]);
      }

      dispatch(ResetEmailRuleFormAddDataReset());
      setSaveType("");
    }
  }, [addSuccess]);

  useEffect(() => {
    if (updateSuccess) {
      navigate("/emailrulelist");
      dispatch(resetEmailRuleFormUpdateData());
      setSaveType("");
    }
  }, [updateSuccess, navigate, dispatch]);




  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[
              {
                href: "/emailrulelist/",
                label: EMAIL_RULE_LIST,
              },
              {
                href: "/emailruleform/",
                label: EMAIL_RULE,
              },
            ]}
          />
        </Col>
        <Col>
          <div className="float-end">
            <Link to="/emailrulelist/">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={BACKTOLIST}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              {(!isEditMode || (emailrule && categoryData.length > 0)) && (
                  <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >

                {({ setFieldValue, values, errors, touched }) => (
                  <Form>
                    {/* EMAIL RULE CONFIGURATION */}
                    <Card className="mb-4">
                      <Card.Header>Email Rule Configuration</Card.Header>
                      <Card.Body>
                        <Row className="g-3">
                          <Col md={6}>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="enabled"
                                name="enabled"
                                checked={values.enabled}
                                onChange={(e) =>
                                  setFieldValue("enabled", e.target.checked)
                                }
                              />
                              <label className="form-check-label" htmlFor="enabled">
                                Active
                              </label>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="form-check single-line-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="stopProcessing"
                                name="stopProcessing"
                                checked={values.stopProcessing}
                                onChange={(e) =>
                                  setFieldValue("stopProcessing", e.target.checked)
                                }
                              />
                              <label className="form-check-label" htmlFor="stopProcessing">
                                If this rule is applied, do not apply further email rules
                              </label>
                            </div>
                          </Col>

                          <Col md={6}>
                            <label className="form-label">
                              Rule Name <span className="error-text">*</span>
                            </label>
                            <Field
                              type="text"
                              name="ruleName"
                              className="form-control"
                              placeholder="Enter rule name"
                            />
                            <ErrorMessage
                              name="ruleName"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          <Col md={6}>
                            <label className="form-label">
                              Incoming email addresses <span className="error-text">*</span>
                            </label>
                            <Field
                              type="text"
                              name="incomingEmailDisplay"
                              className="form-control"
                              readOnly
                            />
                            <ErrorMessage
                              name="incomingEmailAddresses"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          <Col md={12}>
                            <label className="form-label">
                              Description <span className="error-text">*</span>
                            </label>
                            <Field
                              as="textarea"
                              name="description"
                              className="form-control"
                              placeholder="Enter description"
                              rows={3}
                            />
                            <ErrorMessage
                              name="description"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    {/* CONDITION BUILDER */}
                    <Card className="mb-4">
                      <Card.Header>Conditions</Card.Header>
                      <Card.Body>
                        <EmailConditionBuilder
                          values={values}
                          setFieldValue={setFieldValue}
                        />
                        {errors.conditionGroups && touched.conditionGroups && (
                          <div className="alert alert-danger mt-3" role="alert">
                            <i className="bx bx-error-circle me-2"></i>
                            {typeof errors.conditionGroups === 'string' 
                              ? errors.conditionGroups 
                              : 'At least one condition is required'}
                          </div>
                        )}
                      </Card.Body>
                    </Card>

                    {/* ACTIONS CARD */}
                    <Card className="mb-4">
                      <Card.Header>Actions</Card.Header>
                      <Card.Body>
                        <Row className="g-3">
                          <Col md={6}>
                            <label className="form-label">
                              Ticket Type <span className="error-text">*</span>
                            </label>
                            <FormikSelectField
                              name="ticketType"
                              value={values.ticketType}
                              onChange={(name, value) => handleTicketTypeChange(name, value, setFieldValue)}
                              placeholder="Select Ticket Type"
                              required={true}
                            >
                              {TICKET_TYPE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </FormikSelectField>
                            <ErrorMessage
                              name="ticketType"
                              component="div"
                              className="error-text"
                            />
                          </Col>                          
                          <Col md={6}>
                            <label className="form-label">
                              Status <span className="error-text">*</span>
                            </label>
                            <FormikSelectField
                              name="status"
                              value={values.status}
                              onChange={setFieldValue}
                              placeholder="Select Status"
                              required={true}
                            >
                              {statusList && statusList.length > 0 ? (
                                statusList.map((item) => (
                                  <option key={item.value} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              ) : (
                                <option value="">No statuses available</option>
                              )}
                            </FormikSelectField>
                            <ErrorMessage
                              name="status"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                          {/* COMPANY */}
                          <Col md={6}>
                            <label className="form-label">
                              Company <span className="error-text">*</span>
                            </label>
                            <FormikSelectField
                              name="company"
                              value={values.company}
                              onChange={(name, value) => handleCompanyChange(name, value, setFieldValue)}
                              placeholder={!values.ticketType ? "Select a ticket type first" : "Select Company"}
                              required={true}
                              disabled={!values.ticketType}
                            >
                              {companies.map((company) => (
                                <option key={company.id} value={company.id}>
                                  {company.company_name}
                                </option>
                              ))}
                            </FormikSelectField>
                            <ErrorMessage name="company" component="div" className="error-text" />
                          </Col>

                          {/* CATEGORY */}
                          <Col md={6}>
                            <label className="form-label">
                              Category <span className="error-text">*</span>
                            </label>
                            <FormikSelectField
                              name="category"
                              value={values.category}
                              onChange={(name, value) =>
                                handleCategoryChange(name, value, setFieldValue, values.ticketType, values.company)
                              }
                              placeholder={!values.company ? "Select a company first" : "Select Category"}
                              required={true}
                              disabled={!values.ticketType || !values.company}  // <-- add this
                            >
                              {getCategoryOptions(values.ticketType, values.company).map((category) => (
                                <option key={`${category.id}-${category.ticket_type}`} value={category.id}>
                                  {category.name}
                                </option>
                              ))}
                            </FormikSelectField>
                            <ErrorMessage name="category" component="div" className="error-text" />
                          </Col>
                          <Col md={6}>
                            <label className="form-label">
                              Sub Category <span className="error-text">*</span>
                            </label>
                            <FormikSelectField
                              name="subCategory"
                              value={values.subCategory}
                              onChange={(name, value) => handleSubCategoryChange(name, value, setFieldValue, values.ticketType,values.category)}
                              placeholder="Select Sub Category"
                              required={true}
                              disabled={!values.category}
                            >
                              {subCategoryOptions.length > 0 ? (
                                subCategoryOptions.map((subCat) => (
                                  <option key={subCat.config_id} value={subCat.config_id}>
                                    {subCat.s_name}
                                  </option>
                                ))
                              ) : (
                                <option value="">
                                  {values.category ? "No sub categories available" : "Select a category first"}
                                </option>
                              )}
                            </FormikSelectField>
                            <ErrorMessage
                              name="subCategory"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          {values.ticketType === "Ticket" && (
                            <>
                              <Col md={6}>
                                <label className="form-label">Admin Group</label>
                                <FormikSelectField
                                  name="adminGroup"
                                  value={values.adminGroup}
                                  onChange={setFieldValue}
                                  placeholder="Select Admin Group"
                                  required={false}
                                  disabled={true}
                                >
                                  {adminGroup && adminGroup.length > 0 ? (
                                    adminGroup
                                      .filter(group => group.group_id?.toString() === values.adminGroup)
                                      .map((group) => (
                                        <option key={group.group_id} value={group.group_id}>
                                          {group.group_name}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">No admin group available</option>
                                  )}
                                </FormikSelectField>
                              </Col>

                              <Col md={6}>
                                <label className="form-label">Assigned To</label>
                                <FormikSelectField
                                  name="assignedTo"
                                  value={values.assignedTo}
                                  onChange={setFieldValue}
                                  placeholder="Select User"
                                  required={false}
                                  disabled={true}
                                >
                                  {assignedToOptions && assignedToOptions.length > 0 ? (
                                    assignedToOptions.map((user) => (
                                      <option key={user.id} value={user.id}>
                                        {user.emp_name || user.name}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="">No users available</option>
                                  )}
                                </FormikSelectField>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Card.Body>
                    </Card>

                    {/* SUBMIT BUTTONS */}
                    <div className="d-flex gap-3 justify-content-end mt-4 mb-5 pb-5">
                      <DefaultButton
                        buttonClass={"btn btn-secondary me-2"}
                        buttonTitle="Cancel"
                        buttonType="button"
                        actionBlock={() => navigate("/emailrulelist")}
                      />

                      {!isEditMode && (
                        <DefaultButton
                          buttonClass={"btn btn-secondary default-btn-color"}
                          buttonTitle="Save & New"
                          buttonType="button"
                          actionBlock={() => {
                            setSaveType("saveAndNew");
                            document.getElementById("emailRuleFormSubmitBtn").click();
                          }}
                        />
                      )}

                      <DefaultButton
                        buttonClass={"btn btn-secondary default-btn-color"}
                        buttonTitle={SAVE}
                        buttonType="button"
                        actionBlock={() => {
                          setSaveType("save");
                          document.getElementById("emailRuleFormSubmitBtn").click();
                        }}
                      />

                      <button
                        type="submit"
                        id="emailRuleFormSubmitBtn"
                        style={{ display: "none" }}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default EmailRuleForm;